<template>
    <div
        v-loading.fullscreen.lock="pageLoading"
        v-show="pagesData.length!=0">
        <div
            v-if="pageType=='feature-showcase' && currentCertifyData.length > 0"
            class="rl-row-1440 swiper-container rl-row-top-50"
            style="overflow: visible;">
            <div class="feature-showcase-certified-title rl-row-bottom-60">Staff Pick</div>
            <swiper :options="swiperOption">
                <slickTab
                    v-for="(item, index) in currentCertifyData"
                    :key="index"
                    :video="item"
                    :imgdomain="imgdomain"
                    :current-tab="parseInt(currentPage+''+index)"
                    :current-type="$route.params.type"
                    :immediate-link="currentVideoUrl"
                    class="swiper-slide"
                />
            </swiper>
            <div class="swiper-button-next"/>
            <div class="swiper-button-prev"/>
        </div>

        <div class="category-filter">
            <div class="rl-row-1440">
                <div class="rl-row-top-50 breadlink-wrapper">
                    <!-- <a
                        :href="categoriesMappingTable[$route.params.product].link"
                        class="breadlink"
                        target="_self">{{ categoriesMappingTable[$route.params.product].name }}</a>
                    >
                    <a
                        :href="categoriesMappingTable[$route.params.product][pageType].link"
                        class="breadlink"
                        target="_self">{{ categoriesMappingTable[$route.params.product][pageType].name }}</a> -->
                    <span class="breadlink">{{ categoriesMappingTable[$route.params.product].name }}</span>
                    >
                    <span class="breadlink">{{ categoriesMappingTable[$route.params.product][pageType].name }}</span>
                </div>
            </div>
            <!-- <div
                class="header"
                @click="collapseFilter()">
                <div class="current-category">
                    <p v-if="currentCategory==''">
                        All
                    </p>
                    <p v-else>
                        {{ currentCategory }}
                    </p>
                </div>
                <div class="filter-btn">
                    Filter Category
                    <i
                        :class="{'rotate':isCollapseFilter}"
                        class="el-icon-arrow-up"/>
                </div>
            </div> -->
            <el-collapse-transition>
                <div
                    v-show="isCollapseFilter"
                    class="content">
                    <div
                        v-for="(item, index) in categories"
                        :key="index"
                        class="category-item">
                        <div class="title">{{ item.title }}</div>
                        <div
                            v-for="(subItem, index) in item.items"
                            :key="index"
                            class="sub-category">
                            <router-link :to="{path:'/'+item.link+'/'+subItem.type}">
                                {{ subItem.text }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </el-collapse-transition>
            <div class="rl-row-1440">
                <div class="filter-option">
                    <div
                        v-if="pageType=='feature-showcase'"
                        class="type">
                        <el-select
                            v-model="videoType"
                            placeholder="Video Types">
                            <el-option
                                label="Video Types"
                                value=""/>
                            <el-option
                                v-for="item in videoTypeArr"
                                :label="item"
                                :value="item"
                                :key="item"/>
                        </el-select>
                    </div>
                    <div
                        v-if="pageType=='tutorials'"
                        class="version">
                        <el-select
                            v-model="videoVersion"
                            placeholder="Version">
                            <el-option
                                label="Version"
                                value=""/>
                            <el-option
                                v-for="item in versionArr"
                                :label="item"
                                :value="item"
                                :key="item"/>
                        </el-select>
                    </div>
                    <div
                        v-if="pageType=='tutorials'"
                        class="video-category">
                        <el-select
                            v-model="videoCategory"
                            placeholder="Categories">
                            <el-option
                                label="Categories"
                                value=""/>
                            <el-option
                                v-for="item in videoCategoryArr"
                                :label="item"
                                :value="item"
                                :key="item"/>
                        </el-select>

                    </div>

                    <div class="search">
                        <el-input
                            v-model="searchVal"
                            placeholder="Keyword Search"
                            suffix-icon="el-icon-search"/>
                    </div>
                </div>
            </div>
        </div>

        <section class="rl-row-1440">
            <div class="pagination top">
                <div class="">
                    <span>{{ filterData.length }} items</span> ,
                    <span>{{ totalPage }}</span>
                    <span v-if="totalPage!=1"> pages</span>
                    <span v-else>page</span>
                </div>
                <el-pagination
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    :pager-count="7"
                    :total="filterData.length"
                    layout="prev, pager, next"
                    @click="updateMore(currentPage)"/>
            </div>
            <div class="video-container">
                <!-- <div
                    v-for="(item, index) in currentpagesData"
                    :key="index"
                    class="">
                    <div
                        ref="popup"
                        class="video-link rl-rel rl-popup">
                        <a :href="item.Link">
                            <img
                                :src="imgdomain+item.ImageSrc"
                                class="rl-img-response"
                                alt=""
                                srcset="">
                        </a>
                        <div class="rl-play-wrapper">
                            <i class="rl-play"/>
                        </div>
                    </div>
                    <div class="video-author"> {{ item.Author }} </div>
                    <div class="video-title"> {{ item.Title }} </div>
                    <div
                        class="video-desc"
                        v-html="item.Description"/>
                </div> -->
                <videoTab
                    v-for="(item, index) in currentpagesData"
                    :key="index"
                    :video="item"
                    :imgdomain="imgdomain"
                    :current-tab="parseInt(currentPage+''+index)"
                    :current-type="$route.params.type"
                    :immediate-link="currentVideoUrl"/>
                <div
                    v-if="currentpagesData.length == 0"
                    class="">
                    No data Found
                </div>
            </div>
            <div
                v-if="currentpagesData.length != 0"
                class="pagination bottom">
                <div class="">
                    <span>{{ filterData.length }} items</span> ,
                    <span>{{ totalPage }}</span>
                    <span v-if="totalPage!=1"> pages</span>
                    <span v-else>page</span>
                </div>
                <el-pagination
                    :current-page.sync="currentPage"
                    :page-size="pageSize"
                    :pager-count="7"
                    :total="filterData.length"
                    layout="prev, pager, next"
                    :click-handler="backToTop()"/>
            </div>
            <div class="button-outer-wrapper rl-row-40">
                <div class="button-inner-wrapper">
                    <a
                        v-if="pageType==='feature-showcase'"
                        href="https://blog.reallusion.com/"
                        class="none-underline page-button"
                        target="_blank">
                        <button class="banner-btn">
                            SEE USER STORIES >
                        </button>
                    </a>
                    <a
                        v-if="pageType==='content-trailers'"
                        :href="csPortal[$route.params.product]"
                        class="none-underline page-button"
                        target="_blank">
                        <button class="banner-btn">
                            SEE MORE CONTENT >
                        </button>
                    </a>
                    <a
                        v-if="$route.params.product!=='3dxchange'"
                        :href="'https://www.reallusion.com/'+$route.params.product"
                        class="none-underline page-button"
                        target="_blank">
                        <button class="banner-btn">
                            KNOW MORE ABOUT PRODUCT >
                        </button>
                    </a>
                    <a
                        v-if="$route.params.product==='3dxchange'"
                        :href="'https://www.reallusion.com/iClone/pipeline.html'"
                        class="none-underline page-button"
                        target="_blank">
                        <button class="banner-btn">
                            KNOW MORE ABOUT PRODUCT >
                        </button>
                    </a>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import { mapGetters } from "vuex";
    import videoTab from "./video-tab";
    import slickTab from "./slick-tab";
    import store from "@/store";
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        components: {
            videoTab: videoTab,
            slickTab: slickTab,
            swiper,
            swiperSlide
        },
        metaInfo () {
            return {
                title: this.currentCategory,
                meta: [
                    {
                        // set link
                        property: "og:title",
                        content: "Reallusion TV"
                    },
                    {
                        // set link
                        property: "og:type",
                        content: "website"
                    },
                    {
                        // set link
                        property: "og:url",
                        content: "https://www.reallusion.com/reallusiontv/"
                    },
                    {
                        // set link
                        property: "og:site_name",
                        content: "Reallusion TV"
                    }
                ]
            };
        },
        data () {
            return {

                swiperOption: {
                    loop: false,
                    speed: 500,
                    grabCursor: true,
                    slidesPerView: 4,
                    spaceBetween: 30,
                    slidesPerGroup: 4,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    },
                    breakpoints: {
                        1440: {
                            slidesPerView: 3,
                            spaceBetween: 30,
                            slidesPerGroup: 3
                        },
                        991: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                            slidesPerGroup: 2
                        },
                        628: {
                            slidesPerView: 1,
                            spaceBetween: 10,
                            slidesPerGroup: 1
                        }
                    }
                },

                serverConfig: window.rlServerURL,
                imgdomain: "https://www.reallusion.com",
                pageType: this.$route.params.type,
                productCategory: String,
                currentPage: 1,
                certifyPageSize: 4,
                pageSize: 8,
                isCollapseFilter: false,
                videoType: "",
                searchVal: "",
                videoVersion: "",
                videoCategory: "",
                pageLoading: true,
                currentTab: 1,
                currentVideoUrl: "",
                csPortal: {
                    "iclone": "https://www.reallusion.com/contentstore/3d-models.html",
                    "character-creator": "https://www.reallusion.com/contentstore/character-creation.html",
                    "cartoon-animator": "https://www.reallusion.com/contentstore/2d-animation.html",
                    "crazytalk": "https://www.reallusion.com/contentstore/talking-head.html"
                },
                categoriesMappingTable: {
                    iclone: {
                        name: "iClone",
                        link: "#/iclone",
                        "product-demo": {
                            name: "Product Demo",
                            link: "#/iclone/product-demo"
                        },
                        "media-buzz": {
                            name: "Media Buzz",
                            link: "#/iclone/media-buzz"
                        },
                        "case-study": {
                            name: "Case Study",
                            link: "#/iclone/case-study"
                        },
                        "feature-showcase": {
                            name: "Featured Showcase",
                            link: "#/iclone/feature-showcase"
                        },
                        "tutorials": {
                            name: "Tutorials",
                            link: "#/iclone/tutorials"
                        },
                        "content-trailers": {
                            name: "Content Trailers",
                            link: "#/iclone/content-trailers"
                        },
                        "webinar": {
                            name: "Webinar",
                            link: "#/iclone/Webinar"
                        }
                    },
                    "character-creator": {
                        name: "Character Creator",
                        link: "#/character-creator",
                        "product-demo": {
                            name: "Product Demo",
                            link: "#/character-creator/product-demo"
                        },
                        "media-buzz": {
                            name: "Media Buzz",
                            link: "#/character-creator/media-buzz"
                        },
                        "case-study": {
                            name: "Case Study",
                            link: "#/character-creator/case-study"
                        },
                        "feature-showcase": {
                            name: "Featured Showcase",
                            link: "#/character-creator/feature-showcase"
                        },
                        tutorials: {
                            name: "Tutorials",
                            link: "#/character-creator/tutorials"
                        },
                        "content-trailers": {
                            name: "Content Trailers",
                            link: "#/character-creator/content-trailers"
                        },
                        "webinar": {
                            name: "Webinar",
                            link: "#/character-creator/Webinar"
                        }
                    },
                    "cartoon-animator": {
                        name: "Cartoon Animator",
                        link: "#/cartoon-animator",
                        "product-demo": {
                            name: "Product Demo",
                            link: "#/cartoon-animator/product-demo"
                        },
                        "media-buzz": {
                            name: "Media Buzz",
                            link: "#/cartoon-animator/media-buzz"
                        },
                        "case-study": {
                            name: "Case Study",
                            link: "#/cartoon-animator/case-study"
                        },
                        "feature-showcase": {
                            name: "Featured Showcase",
                            link: "#/cartoon-animator/feature-showcase"
                        },
                        tutorials: {
                            name: "Tutorials",
                            link: "#/cartoon-animator/tutorials"
                        },
                        "content-trailers": {
                            name: "Content Trailers",
                            link: "#/cartoon-animator/content-trailers"
                        },
                        "webinar": {
                            name: "Webinar",
                            link: "#/cartoon-animator/Webinar"
                        }
                    },
                    crazytalk: {
                        name: "CrazyTalk",
                        link: "#/crazytalk",
                        "product-demo": {
                            name: "Product Demo",
                            link: "#/crazytalk/product-demo"
                        },
                        "media-buzz": {
                            name: "Media Buzz",
                            link: "#/crazytalk/media-buzz"
                        },
                        "case-study": {
                            name: "Case Study",
                            link: "#/crazytalk/case-study"
                        },
                        "feature-showcase": {
                            name: "Featured Showcase",
                            link: "#/crazytalk/feature-showcase"
                        },
                        tutorials: {
                            name: "Tutorials",
                            link: "#/crazytalk/tutorials"
                        },
                        "content-trailers": {
                            name: "Content Trailers",
                            link: "#/crazytalk/content-trailers"
                        },
                        "webinar": {
                            name: "Webinar",
                            link: "#/crazytalk/Webinar"
                        }
                    },
                    "3dxchange": {
                        name: "3DXchange",
                        link: "#/3dxchange",
                        "product-demo": {
                            name: "Product Demo",
                            link: "#/3dxchange/product-demo"
                        },
                        tutorials: {
                            name: "Tutorials",
                            link: "#/3dxchange/tutorials"
                        }
                    }
                }
            };
        },
        computed: {
            ...mapGetters({ pagesData: "pagesData" }),
            ...mapGetters({ categories: "categories" }),
            ...mapGetters({ pageTypes: "pageTypes" }),
            ...mapGetters({ categoryTypes: "categoryTypes" }),
            currentCategory: function (params) {
                let pageType = this.pageTypes[this.$route.params.type];
                let category = this.categoryTypes[this.$route.params.product];
                return (category === "User Stories") ? category : category + " / " + pageType;
            },
            filterData: function (params) {
                let arr = this.pagesData;
                arr = this.filterVideoType(arr);
                arr = this.filterVideoVersion(arr);
                arr = this.filterVideoSearch(arr);
                arr = this.filterVideoCategory(arr);
                return arr;
            },
            currentpagesData: function () {
                if (this.filterData.length !== 0) {
                    var pageStart = (this.currentPage - 1) * this.pageSize;
                    return this.filterData.slice(
                        pageStart,
                        pageStart + this.pageSize
                    );
                } else {
                    return [];
                }
            },
            currentCertifyData: function () {
                if (this.filterData.length !== 0) {
                    var certifiedData = this.filterData.filter(function (item, index, array) {
                        return item.Certification === true;
                    });
                    certifiedData.sort(function (a, b) {
                        return new Date(b.CreateDate) - new Date(a.CreateDate);
                    });
                    return certifiedData.slice(0, 15);
                } else {
                    return [];
                }
            },
            totalPage: function () {
                return Math.ceil(this.filterData.length / this.pageSize);
            },
            videoTypeArr: function () {
                let arr = [];
                if (this.pagesData.length !== 0) {
                    for (var i in this.pagesData) {
                        var videoAlsoItem = this.pagesData[i].AlsoDisplay;
                        for (var j in videoAlsoItem) {
                            if (videoAlsoItem[j].VideoCategoryName !== null) {
                                arr.push(videoAlsoItem[j].VideoCategoryName);
                            }
                        }
                    }
                }
                return this.uniqueArray(arr);
            },
            versionArr: function () {
                if (this.pageType == "tutorials") {
                    let arr = [];
                    if (this.pagesData.length !== 0) {
                        for (var i in this.pagesData) {
                            var videoAlsoItem = this.pagesData[i].AlsoDisplay;
                            for (var j in videoAlsoItem) {
                                arr.push(videoAlsoItem[j].ProductVersion);
                            }
                        }
                    }
                    return this.uniqueArray(arr);
                }
            },
            videoCategoryArr: function () {
                if (this.pageType == "tutorials") {
                    let arr = [];
                    if (this.pagesData.length !== 0) {
                        for (var i in this.pagesData) {
                            var videoAlsoItem = this.pagesData[i].AlsoDisplay;
                            for (var j in videoAlsoItem) {
                                if (
                                    videoAlsoItem[j].VideoCategoryName != null &&
                                    videoAlsoItem[j].VideoCategoryName != ""
                                ) {
                                    arr.push(videoAlsoItem[j].VideoCategoryName);
                                }
                            }
                        }
                    }
                    return this.uniqueArray(arr);
                }
            }
        },
        watch: {
            $route: function (newVal, oldVal) {
                if (newVal.path !== oldVal.path) {
                    this.getPagesData();
                    this.currentPage = 1;
                    this.pageType = newVal.params.type;
                    this.videoType = "";
                    this.searchVal = "";
                    this.videoVersion = "";
                }
            },
            filterData: function (newVal, oldVal) {
                if (oldVal && this.getVideoId()) {
                    this.popUpVideo(this.getVideoId());
                }
            }
        },
        created: function () {
            this.getPagesData();
        },
        methods: {
            swiperTop () {
                var swiper = new Swiper(".swiper-container", {
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev"
                    }
                });
            },
            getVideoId () {
                return this.$route.query.id ? this.$route.query.id : undefined;
            },
            popUpVideo (id) {
                this.filterData.forEach((video, index) => {
                    if (video.Link.indexOf(id) > -1) {
                        this.turnPage(Math.ceil((index + 1) / this.pageSize));
                        this.currentVideoUrl = video.Link;
                    }
                });
            },
            turnPage (page) {
                this.currentPage = page;
            },
            updateMore () {},
            getPagesData () {
                const vm = this;
                vm.pageLoading = true;
                let data;
                let product;
                let type;
                switch (this.$route.params.product.toLowerCase()) {
                    case "iclone":
                        product = "ic";
                        break;
                    case "character-creator":
                        product = "cc";
                        break;
                    case "crazytalk-animator":
                        product = "cta";
                        break;
                    case "cartoon-animator":
                        product = "cta";
                        break;
                    case "crazytalk":
                        product = "crtl";
                        break;
                    case "3dxchange":
                        product = "3dx";
                        break;
                    case "others":
                        product = "others";
                        break;
                }
                switch (this.$route.params.type) {
                    case "product-demo":
                        type = 0;
                        break;
                    case "media-buzz":
                        type = 1;
                        break;
                    case "case-study":
                        type = 2;
                        break;
                    case "feature-showcase":
                        type = 3;
                        break;
                    case "tutorials":
                        type = 4;
                        break;
                    case "content-trailers":
                        type = 5;
                        break;
                    case "2d-live-show":
                        type = 6;
                        break;
                    case "3d-live-show":
                        type = 7;
                        break;
                    case "webinar":
                        type = 8;
                        break;
                }

                if (product === "others") {
                    data = {
                        SearchConditions: [
                            {
                                ProductType: "apps",
                                VideoType: [type]
                            },
                            {
                                ProductType: "ff",
                                VideoType: [type]
                            },
                            {
                                ProductType: "pv",
                                VideoType: [type]
                            }
                        ]
                    };
                } else {
                    data = {
                        SearchConditions: [
                            {
                                ProductType: product,
                                VideoType: [type]
                            }
                        ]
                    };
                }

                store
                    .dispatch("getPagesData", data)
                    .then(() => {
                        setTimeout(() => {
                            vm.pageLoading = false;
                        }, 1000);
                    })
                    .catch(() => {
                        vm.$router.push("/");
                });
            },
            uniqueArray (arrArg) {
                let unique = [...new Set(arrArg.map(item => item))];
                return unique;
            },
            filterVideoCategory: function (params) {
                if (this.videoCategory !== "") {
                    return params.filter(element => {
                        var videoAlsoItem = element.AlsoDisplay;
                        for (var i in videoAlsoItem) {
                            if (
                                videoAlsoItem[i].VideoCategoryName != null &&
                                videoAlsoItem[i].VideoCategoryName.indexOf(
                                    this.videoCategory
                                ) !== -1 &&
                                (this.videoVersion === "" || (this.videoVersion !== "" &&
                                videoAlsoItem[i].ProductVersion === this.videoVersion))
                            ) {
                                return element;
                            }
                        }
                    });
                } else {
                    return params;
                }
            },
            filterVideoType: function (params) {
                if (this.videoType !== "") {
                    return params.filter(element => {
                        var videoAlsoItem = element.AlsoDisplay;
                        for (var i in videoAlsoItem) {
                            if (
                                videoAlsoItem[i].VideoCategoryName !== null &&
                                videoAlsoItem[i].VideoCategoryName.toLowerCase().indexOf(
                                    this.videoType.toLowerCase()
                                ) !== -1
                            ) {
                                return element;
                            }
                        }
                    });
                } else {
                    return params;
                }
            },
            filterVideoVersion: function (params) {
                if (this.videoVersion !== "") {
                    return params.filter(element => {
                        var videoAlsoItem = element.AlsoDisplay;
                        for (var i in videoAlsoItem) {
                            if (videoAlsoItem[i].ProductVersion == this.videoVersion) {
                                return element;
                            }
                        }
                    });
                } else {
                    return params;
                }
            },
            filterVideoSearch: function (params) {
                if (this.searchVal !== "") {
                    return params.filter(element => {
                        if (
                            element.Title.toLowerCase().indexOf(
                                this.searchVal.toLowerCase()
                            ) !== -1
                        ) {
                            return element;
                        } else if (
                            element.Description.toLowerCase().indexOf(
                                this.searchVal.toLowerCase()
                            ) !== -1
                        ) {
                            return element;
                        } else if (
                            element.Author.toLowerCase().indexOf(
                                this.searchVal.toLowerCase()
                            ) !== -1
                        ) {
                            return element;
                        }
                    });
                } else {
                    return params;
                }
            },
            collapseFilter: function () {
                this.isCollapseFilter = !this.isCollapseFilter;
            },
            backToTop: function () {
                $("html, body").animate({ scrollTop: 0 }, 100);
            }
        }
    };
</script>
<style lang="scss">

.swiper-button-next{
    right: -27px !important;
    @media screen and (max-width: 991px) {
        right: 10px !important;
    }
}
.swiper-button-prev{
    left: -27px !important;
    @media screen and (max-width: 991px) {
        left: 10px !important;
    }
}
.video-container {
    margin-top: 20px;
}
.breadlink,
.breadlink-wrapper {
    text-decoration: none;
    color: #555;
    font-size: calc-responsive(16, 1920, 15, 320);
}
.button-outer-wrapper {
    display: flex;
    justify-content: center;
}
.button-inner-wrapper {
    display: flex;
    justify-content: space-between;
    .page-button{
        @media screen and (max-width: 991px) {
            display: block;
            width: 100%;
        }
    }
    @media screen and (max-width: 991px) {
        flex-wrap: wrap;
    }
}
.banner-btn {
    max-width: initial;
    font-size: calc(0.25vw + 15.2px);

}

.page-button + .page-button{
    margin-left: calc(0.625vw + 18px);
    @media screen and (max-width: 991px) {
        margin-left: 0;
        margin-top: 20px;
    }
}

.feature-showcase-certified-title {
    font-size: calc(1.5625vw + 18px);
    font-weight: 300;
    color: #555;
}
</style>



// WEBPACK FOOTER //
// src/components/page.vue